import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import { useTranslation } from "../../utils/useTranslation";
import {
  StyleSheet,
  ScrollView,
  Text,
  TouchableOpacity,
  View as RNView,
  Modal,
  Pressable,
  Platform,
} from "react-native";
import { useIsFocused } from "@react-navigation/native";
import { replaceDataValues, renameLabel } from "../../utils/common";
import { View } from "../../components/shared/Themed";
import { LabelBannerWithSearchBar } from "../../components/custom/Banners/LabelBannerWithSearchBar";
import { DataTableWithPagination } from "../../components/custom/DataTable/DataTableWithPagination";
import Spinner from "../../components/shared/Spinner";
import FeatherIcon from "react-native-vector-icons/Feather";
import AsyncStorage from "@react-native-async-storage/async-storage";
import useColorScheme from "../../hooks/useColorScheme";
import { userClaimInformation } from "../../models/usersModel";
import _ from "lodash";
import { getDelivery } from "../../services/deliveryService";
import {
  headers,
  mdHeaders,
  smHeaders,
  phoneHeaders,
} from "./utils/deliveryHeaders";
import {
  nestedHeaders as deliveryHeader,
  mdNestedHeaders as deliveryMdHeaders,
  smNestedHeaders as deliverySmHeaders,
} from "./utils/deliveryDetailsHeaders";
import { deliveryModel } from "../../models/reportsModel";
import { filterBasedOnAnyKey } from "../../utils/searchInArrays";
import DeviceOrientationContext from "../../components/context/DeviceOrientationContext";
import { useSelector } from "react-redux";
import { handleTableLoader } from "../../utils/common";
import { sortColumns } from "../../utils/sortColumns";
import { UploadAttachmentDeliveryModal } from "./utils/UploadAttachmentDeliveryContent";
import { DeliveryStatusConfirmModal } from "./utils/DeliveryStatusConfirmModal";
import { DownloadPdfDeliveryModal } from "./utils/DownloadPdfDeliveryContent";
import { DatePickerModal, registerTranslation } from "react-native-paper-dates";
import { Provider as PaperProvider, DefaultTheme } from "react-native-paper";

registerTranslation("en-AU", {
  save: "Save",
  selectSingle: "Select date",
  selectMultiple: "Select dates",
  selectRange: "Select period",
  notAccordingToDateFormat: (inputFormat) =>
    `Date format must be ${inputFormat}`,
  mustBeHigherThan: (date) => `Must be later than ${date}`,
  mustBeLowerThan: (date) => `Must be earlier than ${date}`,
  mustBeBetween: (startDate, endDate) =>
    `Must be between ${startDate} - ${endDate}`,
  dateIsDisabled: "Day is not allowed",
  previous: "Previous",
  next: "Next",
  typeInDate: "Type in date",
  pickDateFromCalendar: "Pick date from calendar",
  close: "Close",
  hour: "Hour",
  minute: "Minute",
  startDate: "Start Date (DD/MM/YYYY)",
  endDate: "End Date (DD/MM/YYYY)",
  dateFormat: "DD/MM/YYYY",
});

export default function DeliverytScreen({ route, navigation }: any) {
  const scrollRef = useRef<ScrollView>(null);
  const isFocused = useIsFocused();
  const { t } = useTranslation();
  const colorScheme = useColorScheme();

  const columnsToNotHaveThousandsSeparator: Array<string> = [
    "documentNo",
    "reference",
    "documentNo",
    "portalOrderNo",
    "DocNum",
  ];
  const dataToBeConverted: object = {
    /*{ "searchString" : "replaceValue" }*/
    Dispatched: "Shipped",
    "Not Confirmed": "Pending for Payment",
  };

  const { userInfo } = useSelector((state: any) => state.configurations);
  const [isRefresh, setRefresh] = useState<boolean>(false);
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [isImageLoading, setImageLoading] = useState<boolean>(true);
  const [deliveryAttachmentModalVisible, setDeliveryAttachmentModalVisible] =
    useState<boolean>(false);
  const [deliveryStatusModal, setDeliveryStatusModal] =
    useState<boolean>(false);
  const [downloadPdfModalVisible, setDownloadPdfModalVisible] =
    useState<boolean>(false);
  const [deliveryPageLevelList, setDeliveryPageLevelList] = useState<
    Array<deliveryModel>
  >([]);

  const { isLargeDevice, isMediumDevice, isMobileDevice, isSmallDevice } =
    useContext(DeviceOrientationContext);

  const [_stateFilter, _setStateFilter] = useState<string>("all");
  const [_dateFilter, _setDateFilter] = useState<string>("Today");
  const [selectedStates, setSelectedStates] = useState<string[]>([]);
  const [selectedDates, setSelectedDates] = useState<string[]>(["Today"]);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [dateRangePickerOpen, setDateRangePickerOpen] =
    useState<boolean>(false);
  const [customDateRange, setCustomDateRange] = useState<{
    startDate: Date | undefined;
    endDate: Date | undefined;
  }>({ startDate: undefined, endDate: undefined });

  const stateFilters = ["all", "NSW", "VIC", "QLD", "WA", "SA", "TAS"];
  const dateFilters = [
    "All",
    "Yesterday",
    "Today",
    "Next date",
    "Next 7 days",
    "Date Range",
  ];

  const formatShortDate = (d: Date) => {
    const day = d.getDate();
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const year = String(d.getFullYear()).slice(-2);
    return `${day}-${months[d.getMonth()]}-${year}`;
  };

  const getDateRangeLabel = () => {
    if (customDateRange.startDate && customDateRange.endDate) {
      return `${formatShortDate(customDateRange.startDate)} to ${formatShortDate(customDateRange.endDate)}`;
    }
    return "Date Range";
  };
  const { userRoles } = useSelector((state: any) => state.configurations);

  const { deliveryList, deliveryListFilterCategoryList, isDeliveryListLoaded } =
    useSelector((state: any) => state.delivery);

  const { deliveryItemsList } = useSelector((state: any) => state.items);

  const [selected, setSelected] = useState<deliveryModel>(
    {} as unknown as deliveryModel,
  );

  const [selectedDeliveryItem, setSelectedDeliveryItem] = useState<any>(
    {} as unknown as any,
  );

  //Table & Nested Table Headers
  const [tableHeaders, setTableHeaders] =
    useState<Record<string, Record<string, string | number | boolean>>>(
      headers,
    );

  const [nestedTableHeaders, setNestedTableHeaders] =
    useState<Record<string, Record<string, string | number | boolean>>>(
      deliveryHeader,
    );

  const [_isDisplayViewOn, _setIsDisplayViewOn] = useState(false);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [filterExpanded, setFilterExpanded] = useState<boolean>(true);
  const [mobileFilterOpen, setMobileFilterOpen] = useState<
    "state" | "date" | "status" | null
  >(null);

  const [, setContentOffSet] = useState<number>(0);
  const [columnSettingsOpen, setColumnSettingsOpen] = useState<boolean>(false);
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [columnOrder, setColumnOrder] = useState<string[]>([]);
  const [settingsBtnPos, setSettingsBtnPos] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const settingsBtnRef = useRef<any>(null);

  const handleDownloadPdf = (row: any) => {
    setSelectedDeliveryItem(row);
    setDownloadPdfModalVisible(true);
  };

  // Load saved hidden columns from storage on mount
  useEffect(() => {
    AsyncStorage.getItem("delivery_hidden_columns").then((stored) => {
      if (stored) {
        try {
          setHiddenColumns(JSON.parse(stored));
        } catch {}
      }
    });
    AsyncStorage.getItem("delivery_column_order").then((stored) => {
      if (stored) {
        try {
          setColumnOrder(JSON.parse(stored));
        } catch {}
      }
    });
  }, []);

  // All available column
  const getAllHeaders = () => {
    return isLargeDevice
      ? headers
      : isMediumDevice
        ? mdHeaders
        : isMobileDevice
          ? phoneHeaders
          : smHeaders;
  };

  const getOrderedKeys = (
    baseHeaders: Record<string, Record<string, string | number | boolean>>,
  ) => {
    const allKeys = Object.keys(baseHeaders);
    if (columnOrder.length === 0) return allKeys;
    const ordered: string[] = [];
    columnOrder.forEach((k) => {
      if (allKeys.includes(k)) ordered.push(k);
    });
    allKeys.forEach((k) => {
      if (!ordered.includes(k)) ordered.push(k);
    });
    return ordered;
  };

  const getFilteredHeaders = (
    baseHeaders: Record<string, Record<string, string | number | boolean>>,
  ) => {
    const orderedKeys = getOrderedKeys(baseHeaders);
    const visibleEntries = orderedKeys
      .filter((key) => !hiddenColumns.includes(key))
      .map(
        (key) =>
          [key, baseHeaders[key]] as [
            string,
            Record<string, string | number | boolean>,
          ],
      );
    const totalOriginalFlex = Object.values(baseHeaders).reduce(
      (sum, h) => sum + (Number(h.width) || 0),
      0,
    );
    const totalVisibleFlex = visibleEntries.reduce(
      (sum, [, h]) => sum + (Number(h.width) || 0),
      0,
    );
    const scale =
      totalVisibleFlex > 0 ? totalOriginalFlex / totalVisibleFlex : 1;

    const result: Record<
      string,
      Record<string, string | number | boolean>
    > = {};
    visibleEntries.forEach(([key, value]) => {
      result[key] = { ...value, width: Number(value.width) * scale };
    });
    return result;
  };

  useEffect(() => {
    if (isSmallDevice || isMobileDevice) return;
    const allHeaders = getAllHeaders();
    setTableHeaders(getFilteredHeaders(allHeaders));
  }, [hiddenColumns, columnOrder, isLargeDevice, isMediumDevice]);

  const toggleColumn = (columnKey: string) => {
    setHiddenColumns((prev) => {
      const updated = prev.includes(columnKey)
        ? prev.filter((k) => k !== columnKey)
        : [...prev, columnKey];
      AsyncStorage.setItem("delivery_hidden_columns", JSON.stringify(updated));
      return updated;
    });
  };

  const moveColumn = useCallback(
    (fromKey: string, toKey: string) => {
      const allHeaders = getAllHeaders();
      const currentKeys = getOrderedKeys(allHeaders).filter((k) => k !== "");
      const fromIdx = currentKeys.indexOf(fromKey);
      const toIdx = currentKeys.indexOf(toKey);
      if (fromIdx < 0 || toIdx < 0 || fromIdx === toIdx) return;
      const newKeys = [...currentKeys];
      newKeys.splice(fromIdx, 1);
      newKeys.splice(toIdx, 0, fromKey);
      newKeys.push("");
      setColumnOrder(newKeys);
      AsyncStorage.setItem("delivery_column_order", JSON.stringify(newKeys));
    },
    [columnOrder],
  );

  const resetColumnOrder = () => {
    setColumnOrder([]);
    AsyncStorage.removeItem("delivery_column_order");
  };

  // Drag-and-drop reordering via window mouse events
  const [dragActiveKey, setDragActiveKey] = useState<string | null>(null);
  const [dragOverKey, setDragOverKey] = useState<string | null>(null);
  const dragRef = useRef<{ activeKey: string | null; overKey: string | null }>({
    activeKey: null,
    overKey: null,
  });

  const startColumnDrag = useCallback(
    (key: string) => {
      if (Platform.OS !== "web" || typeof window === "undefined") return;
      dragRef.current.activeKey = key;
      setDragActiveKey(key);

      const onMouseMove = (e: MouseEvent) => {
        const el = document.elementFromPoint(e.clientX, e.clientY);
        const row =
          el && (el as HTMLElement).closest
            ? (el as HTMLElement).closest("[data-columnkey]")
            : null;
        const overKey = row ? row.getAttribute("data-columnkey") : null;
        if (overKey !== dragRef.current.overKey) {
          dragRef.current.overKey = overKey;
          setDragOverKey(
            overKey && overKey !== dragRef.current.activeKey ? overKey : null,
          );
        }
      };

      const onMouseUp = () => {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        document.body.style.cursor = "";
        (document.body.style as any).userSelect = "";
        const from = dragRef.current.activeKey;
        const to = dragRef.current.overKey;
        if (from && to && from !== to) {
          moveColumn(from, to);
        }
        dragRef.current = { activeKey: null, overKey: null };
        setDragActiveKey(null);
        setDragOverKey(null);
      };

      document.body.style.cursor = "grabbing";
      (document.body.style as any).userSelect = "none";
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
    },
    [moveColumn],
  );

  const filterDeliveryByCategory = (
    _deliveryMode: Array<deliveryModel>,
    stateFilter: string,
    dateFilter: string,
    stateFiltersArr?: string[],
    dateFiltersArr?: string[],
    statusFiltersArr?: string[],
  ) => {
    const currentDate = new Date();
    const yesterday = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() - 1,
    );
    const today = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
    );
    const tomorrow = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 1,
    );
    const Nxt7Days = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 7,
    );
    const Nxt14Days = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 14,
    );
    const Nxt30Days = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 30,
    );

    const getDateRange = (filter: string): [Date, Date] | null => {
      switch (filter) {
        case "Yesterday":
          return [yesterday, yesterday];
        case "Today":
          return [today, today];
        case "Next date":
          return [tomorrow, tomorrow];
        case "Next 7 days":
          return [today, Nxt7Days];
        case "Next 14 days":
          return [today, Nxt14Days];
        case "Next 30 days":
          return [today, Nxt30Days];
        case "Date Range":
          if (customDateRange.startDate && customDateRange.endDate) {
            return [customDateRange.startDate, customDateRange.endDate];
          }
          return null;
        default:
          return null;
      }
    };

    return _deliveryMode.filter((delivery: deliveryModel) => {
      // Apply state filter (multi-select)
      let matchesState = true;
      const activeStates =
        stateFiltersArr && stateFiltersArr.length > 0
          ? stateFiltersArr
          : stateFilter !== "all"
            ? [stateFilter]
            : [];
      if (activeStates.length > 0) {
        matchesState = activeStates.includes(delivery.State);
      }

      // Apply date filter (multi-select)
      let matchesDate = true;
      const activeDates =
        dateFiltersArr && dateFiltersArr.length > 0
          ? dateFiltersArr
          : [dateFilter];
      const requestDate = new Date(
        new Date(delivery.RequestDate).getFullYear(),
        new Date(delivery.RequestDate).getMonth(),
        new Date(delivery.RequestDate).getDate(),
      );

      if (activeDates.length > 0) {
        matchesDate = activeDates.some((df) => {
          const range = getDateRange(df);
          if (!range) return true;
          return requestDate >= range[0] && requestDate <= range[1];
        });
      }

      // Apply status filter (multi-select)
      let matchesStatus = true;
      if (statusFiltersArr && statusFiltersArr.length > 0) {
        matchesStatus = statusFiltersArr.includes(delivery.OrderStatus);
      }

      return matchesState && matchesDate && matchesStatus;
    });
  };

  const onHandleSortColumn = (columnKey: string) => {
    const _sortedDeliveryList: Array<deliveryModel> = sortColumns(
      deliveryPageLevelList,
      columnKey,
      tableHeaders,
      setTableHeaders,
    );

    setDeliveryPageLevelList(
      filterDeliveryByCategory(
        _sortedDeliveryList,
        _stateFilter,
        _dateFilter,
        selectedStates,
        selectedDates,
        selectedStatuses,
      ),
    );
  };

  /**
   * TODO: NESTED TABLE SORTED Is Disabled,
   * enable when sorting on nested table feature is requested
   */
  // const onHandleNestedSortColumn = (
  //   columnKey: string,
  //   columnParentIdentifier: string
  // ) => {
  //   const _sortedItemsList: Array<itemsModal> = sortColumns(
  //     nestedItemsPageLevelList,
  //     columnKey,
  //     nestedTableHeaders,
  //     setNestedTableHeaders
  //   );

  //   setNestedItemsPageLevelList(_sortedItemsList);
  // };

  const onHandleScroll = (event: any) => {
    setContentOffSet(Math.floor(event.nativeEvent?.contentOffset?.y) ?? 0);
  };

  const onHandleRowClick = (row: deliveryModel) => {};

  const fadeTableLoader = (setIsSearched: (e: boolean) => void) => {
    handleTableLoader(false, true, setIsSearched);
  };

  const onHandleRemoveRow = (containerId: string) => {};

  const onHandleSearch = (searchText: string) => {
    displayTableLoader(setIsSearched);

    let searchedDelivery: Array<deliveryModel> = [];
    if (searchText.trim() !== "") {
      /**
       * When SearchBy: Delivery, enter into if block
       * otherwise go for else block
       */
      if (!_isDisplayViewOn) {
        const filteredDelivery = filterBasedOnAnyKey(
          extractIdenticalDelivery(),
          searchText,
        );

        searchedDelivery = feedItemsInDelivery(filteredDelivery);
      } else {
        /**
         * Steps to search for items within containers
         * 1: Extract all items from containers & union them
         * 2: Search by keyword in the list of items extracted from containers
         * 3: Group by container_number on the searchedItems
         * 4: Remove the duplicates from array of container_numbers
         * 5: filter the unique containers from the identicalFeededDeliveryWithItems()
         *    & return the list of containers with items matching the search text
         */

        //Step 1
        const itemsFromDelivery = _.map(
          identicalFeededDeliveryWithItems(),
          "items",
        );
        const flattenItems = _.flatten(itemsFromDelivery);

        //Step 2
        const searchedItems = filterBasedOnAnyKey(flattenItems, searchText);

        //Step 3
        const groupedDelivery = Object.keys(_.groupBy(searchedItems, "DocNum"));

        //Step 4
        const uniqueDelivery = _.uniq(groupedDelivery);

        //Step 5
        const filteredDelivery = identicalFeededDeliveryWithItems().filter(
          (delivery) => uniqueDelivery.includes(delivery.DocNum),
        );

        searchedDelivery = filteredDelivery;
      }

      // Search all! Bypass category filters when searching.
      setDeliveryPageLevelList(searchedDelivery);
    } else {
      // Empty search text -> restore original filters
      const unique = [
        ...identicalFeededDeliveryWithItems()
          .reduce((map, obj) => {
            if (!map.has(obj.DocNum)) map.set(obj.DocNum, obj);
            return map;
          }, new Map())
          .values(),
      ];
      setDeliveryPageLevelList(
        filterDeliveryByCategory(
          unique,
          _stateFilter,
          _dateFilter,
          selectedStates,
          selectedDates,
          selectedStatuses,
        ),
      );
    }

    setTimeout(() => {
      fadeTableLoader(setIsSearched);
    }, 2000);
  };

  const extractIdenticalDelivery = () => {
    const _deliveryItemsList: Array<deliveryModel> = deliveryList;
    const unique = [
      ..._deliveryItemsList
        .reduce((map, obj) => {
          if (!map.has(obj.DocNum)) map.set(obj.DocNum, obj);
          return map;
        }, new Map())
        .values(),
    ];
    return unique as Array<deliveryModel>;
  };

  const feedItemsInDelivery = (delivery: deliveryModel[]) => {
    const _deliveryItemsList: Array<deliveryModel> = [...deliveryList];

    return delivery.map((_delivery) => {
      return {
        ..._delivery,
        items: _deliveryItemsList.filter(
          (item: deliveryModel) => item.DocNum === _delivery.DocNum,
        ),
      };
    });
  };

  const identicalFeededDeliveryWithItems = (): Array<deliveryModel> => {
    return feedItemsInDelivery(extractIdenticalDelivery());
  };

  const displayTableLoader = (
    setIsSearched: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    handleTableLoader(true, false, setIsSearched);
  };

  useEffect(() => {
    setRefresh(true);
  }, [_isDisplayViewOn]);

  useEffect(() => {
    let isMounted: boolean = true;
    const _userInfo = userInfo as userClaimInformation;
    // Avoid keep refreshing table when item is selected
    if (isMounted) {
      if (deliveryPageLevelList.length === 0 || isRefresh) {
        displayTableLoader(setIsSearched);
        _setStateFilter("all");
        _setDateFilter("Today");
        setSelectedStates([]);
        setSelectedDates(["Today"]);
        getDelivery(
          "DeliveryReport",
          "",
          _userInfo.team,
          _userInfo.zone_info || "",
          "delivery_report",
          tableHeaders,
        );
      }
    }

    const baseHeaders = isLargeDevice
      ? headers
      : isMediumDevice
        ? mdHeaders
        : isMobileDevice
          ? phoneHeaders
          : smHeaders;
    setTableHeaders(
      isSmallDevice || isMobileDevice
        ? baseHeaders
        : getFilteredHeaders(baseHeaders),
    );

    setNestedTableHeaders(
      isLargeDevice
        ? deliveryHeader
        : isMediumDevice
          ? deliveryMdHeaders
          : deliverySmHeaders,
    );

    setRefresh(false);

    return () => {
      isMounted = false;
    };
  }, [
    isFocused,
    isRefresh,
    _dateFilter === "Today",
    columnOrder,
    hiddenColumns,
    isLargeDevice,
    isMediumDevice,
    isSmallDevice,
    isMobileDevice,
  ]);

  useEffect(() => {
    const unique = [
      ...identicalFeededDeliveryWithItems()
        .reduce((map, obj) => {
          if (!map.has(obj.DocNum)) map.set(obj.DocNum, obj);
          return map;
        }, new Map())
        .values(),
    ];
    setDeliveryPageLevelList(
      filterDeliveryByCategory(
        unique,
        _stateFilter,
        _dateFilter,
        selectedStates,
        selectedDates,
        selectedStatuses,
      ),
    );

    setTimeout(() => {
      fadeTableLoader(setIsSearched);
    }, 2000);
  }, [
    deliveryList,
    deliveryItemsList,
    _stateFilter,
    _dateFilter,
    selectedStates,
    selectedDates,
    selectedStatuses,
  ]);

  const navigateToReportDetails = (order: any, action: string) => {
    navigation.navigate("DeliveryDetailsScreen", { order });
  };

  const availableStatuses = Array.from(
    new Set((deliveryList || []).map((item: any) => item.OrderStatus)),
  ).filter(Boolean) as string[];

  return (
    <ScrollView
      style={{ backgroundColor: colorScheme === "light" ? "white" : "white" }}
      onScroll={onHandleScroll}
      ref={scrollRef}
    >
      <View
        style={{ backgroundColor: colorScheme === "light" ? "white" : "white" }}
      >
        <View
          style={[
            styles.container,
            {
              backgroundColor: colorScheme === "light" ? "#f2f2f2" : "#f2f2f2",
            },
          ]}
        >
          <View
            style={[
              styles.containerContent,
              {
                width: isLargeDevice
                  ? "100%"
                  : isMediumDevice
                    ? "100%"
                    : "100%",
              },
            ]}
          >
            {isDeliveryListLoaded ? (
              <View>
                {isSmallDevice || isMobileDevice ? (
                  <>
                    <View style={{ paddingHorizontal: 10, paddingTop: 10 }}>
                      <LabelBannerWithSearchBar
                        titleName={`${t("totalDelivery")}: ${deliveryPageLevelList.length}`}
                        handleSearch={onHandleSearch}
                        setRefresh={setRefresh}
                        isResetFields={isRefresh}
                        extraControls={
                          !(isSmallDevice || isMobileDevice) ? (
                            <RNView>
                              <TouchableOpacity
                                ref={settingsBtnRef}
                                style={{
                                  width:
                                    isSmallDevice || isMobileDevice ? 34 : 40,
                                  height:
                                    isSmallDevice || isMobileDevice ? 34 : 40,
                                  borderRadius:
                                    isSmallDevice || isMobileDevice ? 8 : 10,
                                  backgroundColor: columnSettingsOpen
                                    ? "#E0E7FF"
                                    : "#F3F4F6",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderWidth: 1,
                                  borderColor: columnSettingsOpen
                                    ? "#818CF8"
                                    : "#E2E8F0",
                                }}
                                onPress={() => {
                                  if (settingsBtnRef.current) {
                                    settingsBtnRef.current.measureInWindow(
                                      (
                                        x: number,
                                        y: number,
                                        width: number,
                                        height: number,
                                      ) => {
                                        setSettingsBtnPos({
                                          x,
                                          y,
                                          width,
                                          height,
                                        });
                                        setColumnSettingsOpen(
                                          !columnSettingsOpen,
                                        );
                                      },
                                    );
                                  } else {
                                    setColumnSettingsOpen(!columnSettingsOpen);
                                  }
                                }}
                              >
                                <FeatherIcon
                                  name="settings"
                                  size={
                                    isSmallDevice || isMobileDevice ? 14 : 15
                                  }
                                  color={
                                    columnSettingsOpen ? "#56B7FD" : "#6B7280"
                                  }
                                />
                              </TouchableOpacity>
                              <Modal
                                visible={columnSettingsOpen}
                                transparent={true}
                                animationType="fade"
                                onRequestClose={() =>
                                  setColumnSettingsOpen(false)
                                }
                              >
                                <Pressable
                                  style={{
                                    flex: 1,
                                    backgroundColor: "rgba(0,0,0,0.15)",
                                    ...(isSmallDevice || isMobileDevice
                                      ? {
                                          justifyContent: "center",
                                          alignItems: "center",
                                          padding: 20,
                                        }
                                      : {}),
                                  }}
                                  onPress={() => setColumnSettingsOpen(false)}
                                >
                                  <Pressable
                                    style={{
                                      ...(isSmallDevice || isMobileDevice
                                        ? { width: "100%", maxWidth: 320 }
                                        : {
                                            position: "absolute",
                                            top:
                                              settingsBtnPos.y +
                                              settingsBtnPos.height +
                                              6,
                                            left: settingsBtnPos.x,
                                            minWidth: 220,
                                          }),
                                      backgroundColor: "#fff",
                                      borderRadius: 12,
                                      borderWidth: 1,
                                      borderColor: "#E2E8F0",
                                      paddingVertical: 10,
                                      shadowColor: "#000",
                                      shadowOffset: { width: 0, height: 8 },
                                      shadowOpacity: 0.15,
                                      shadowRadius: 20,
                                      elevation: 10,
                                    }}
                                    onPress={(e) => e.stopPropagation()}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        fontWeight: "700",
                                        color: "#6B7280",
                                        paddingHorizontal: 16,
                                        paddingBottom: 8,
                                        textTransform: "uppercase",
                                        letterSpacing: 0.5,
                                      }}
                                    >
                                      {t("showHideColumns")}
                                    </Text>
                                    <View
                                      style={{
                                        height: 1,
                                        backgroundColor: "#F1F5F9",
                                        marginBottom: 4,
                                      }}
                                    />
                                    {/* Select All */}
                                    <TouchableOpacity
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        paddingVertical: 8,
                                        paddingHorizontal: 16,
                                      }}
                                      onPress={() => {
                                        const allKeys = Object.keys(
                                          getAllHeaders(),
                                        ).filter((k) => k !== "");
                                        if (hiddenColumns.length === 0) {
                                          // Hide all
                                          const updated = [...allKeys];
                                          setHiddenColumns(updated);
                                          AsyncStorage.setItem(
                                            "delivery_hidden_columns",
                                            JSON.stringify(updated),
                                          );
                                        } else {
                                          // Show all
                                          setHiddenColumns([]);
                                          AsyncStorage.setItem(
                                            "delivery_hidden_columns",
                                            JSON.stringify([]),
                                          );
                                        }
                                      }}
                                    >
                                      <View
                                        style={{
                                          width: 20,
                                          height: 20,
                                          borderRadius: 4,
                                          borderWidth: 1.5,
                                          borderColor:
                                            hiddenColumns.length === 0
                                              ? "#56B7FD"
                                              : "#D1D5DB",
                                          backgroundColor:
                                            hiddenColumns.length === 0
                                              ? "#56B7FD"
                                              : "#fff",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          marginRight: 10,
                                        }}
                                      >
                                        {hiddenColumns.length === 0 && (
                                          <FeatherIcon
                                            name="check"
                                            size={13}
                                            color="#fff"
                                          />
                                        )}
                                      </View>
                                      <Text
                                        style={{
                                          fontSize: 14,
                                          color: "#111827",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {t("selectAll")}
                                      </Text>
                                    </TouchableOpacity>
                                    <View
                                      style={{
                                        height: 1,
                                        backgroundColor: "#F1F5F9",
                                        marginBottom: 2,
                                      }}
                                    />
                                    <ScrollView
                                      style={{ maxHeight: 300 }}
                                      showsVerticalScrollIndicator={true}
                                    >
                                      {getOrderedKeys(getAllHeaders()).map(
                                        (key) => {
                                          if (key === "") return null;
                                          const value = getAllHeaders()[key];
                                          if (!value) return null;
                                          const isVisible =
                                            !hiddenColumns.includes(key);
                                          const isDragging =
                                            dragActiveKey === key;
                                          const isDragOver =
                                            dragOverKey === key;
                                          return (
                                            <RNView
                                              key={key}
                                              {...({
                                                dataSet: { columnkey: key },
                                              } as any)}
                                              style={{
                                                flexDirection: "row",
                                                alignItems: "center",
                                                paddingVertical: 8,
                                                paddingHorizontal: 16,
                                                opacity: isDragging ? 0.35 : 1,
                                                backgroundColor: isDragOver
                                                  ? "#EFF6FF"
                                                  : "transparent",
                                                borderTopWidth: isDragOver
                                                  ? 2
                                                  : 0,
                                                borderTopColor: "#56B7FD",
                                              }}
                                            >
                                              <Pressable
                                                onPressIn={() =>
                                                  startColumnDrag(key)
                                                }
                                                style={
                                                  {
                                                    padding: 4,
                                                    marginRight: 6,
                                                    cursor: "grab",
                                                  } as any
                                                }
                                              >
                                                <FeatherIcon
                                                  name="menu"
                                                  size={14}
                                                  color="#9CA3AF"
                                                />
                                              </Pressable>
                                              <TouchableOpacity
                                                style={{
                                                  flexDirection: "row",
                                                  alignItems: "center",
                                                  flex: 1,
                                                }}
                                                onPress={() =>
                                                  toggleColumn(key)
                                                }
                                              >
                                                <RNView
                                                  style={{
                                                    width: 20,
                                                    height: 20,
                                                    borderRadius: 4,
                                                    borderWidth: 1.5,
                                                    borderColor: isVisible
                                                      ? "#56B7FD"
                                                      : "#D1D5DB",
                                                    backgroundColor: isVisible
                                                      ? "#56B7FD"
                                                      : "#fff",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginRight: 10,
                                                  }}
                                                >
                                                  {isVisible && (
                                                    <FeatherIcon
                                                      name="check"
                                                      size={13}
                                                      color="#fff"
                                                    />
                                                  )}
                                                </RNView>
                                                <Text
                                                  style={{
                                                    fontSize: 14,
                                                    color: isVisible
                                                      ? "#111827"
                                                      : "#9CA3AF",
                                                    fontWeight: isVisible
                                                      ? "600"
                                                      : "400",
                                                  }}
                                                >
                                                  {t((value as any).name)}
                                                </Text>
                                              </TouchableOpacity>
                                            </RNView>
                                          );
                                        },
                                      )}
                                    </ScrollView>
                                    {columnOrder.length > 0 && (
                                      <>
                                        <RNView
                                          style={{
                                            height: 1,
                                            backgroundColor: "#F1F5F9",
                                            marginTop: 4,
                                          }}
                                        />
                                        <TouchableOpacity
                                          style={{
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            paddingVertical: 10,
                                            paddingHorizontal: 16,
                                          }}
                                          onPress={resetColumnOrder}
                                        >
                                          <FeatherIcon
                                            name="rotate-ccw"
                                            size={13}
                                            color="#6B7280"
                                          />
                                          <Text
                                            style={{
                                              fontSize: 13,
                                              color: "#6B7280",
                                              fontWeight: "600",
                                              marginLeft: 6,
                                            }}
                                          >
                                            {t("resetOrder")}
                                          </Text>
                                        </TouchableOpacity>
                                      </>
                                    )}
                                  </Pressable>
                                </Pressable>
                              </Modal>
                            </RNView>
                          ) : undefined
                        }
                      />
                    </View>
                    <View
                      style={{ paddingHorizontal: 10, paddingVertical: 10 }}
                    >
                      <ScrollView
                        horizontal
                        showsHorizontalScrollIndicator={false}
                      >
                        <TouchableOpacity
                          style={[
                            deliveryFilterStyles.mobileDropdownButton,
                            mobileFilterOpen === "date" &&
                              deliveryFilterStyles.mobileDropdownButtonActive,
                          ]}
                          onPress={() =>
                            setMobileFilterOpen(
                              mobileFilterOpen === "date" ? null : "date",
                            )
                          }
                        >
                          <Text
                            style={deliveryFilterStyles.mobileDropdownLabel}
                          >
                            {t("date")}:{" "}
                          </Text>
                          <Text
                            style={deliveryFilterStyles.mobileDropdownValue}
                          >
                            {selectedDates.length === 0
                              ? "All"
                              : selectedDates.length === 1
                                ? selectedDates[0] === "Date Range"
                                  ? getDateRangeLabel()
                                  : selectedDates[0]
                                : `${selectedDates.length} ${t("selected")}`}
                          </Text>
                          <Text
                            style={deliveryFilterStyles.mobileDropdownArrow}
                          >
                            {mobileFilterOpen === "date" ? "▲" : "▼"}
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={[
                            deliveryFilterStyles.mobileDropdownButton,
                            mobileFilterOpen === "state" &&
                              deliveryFilterStyles.mobileDropdownButtonActive,
                            { marginLeft: 16 },
                          ]}
                          onPress={() =>
                            setMobileFilterOpen(
                              mobileFilterOpen === "state" ? null : "state",
                            )
                          }
                        >
                          <Text
                            style={deliveryFilterStyles.mobileDropdownLabel}
                          >
                            {t("state")}:{" "}
                          </Text>
                          <Text
                            style={deliveryFilterStyles.mobileDropdownValue}
                          >
                            {selectedStates.length === 0
                              ? "All"
                              : selectedStates.length === 1
                                ? selectedStates[0]
                                : `${selectedStates.length} ${t("selected")}`}
                          </Text>
                          <Text
                            style={deliveryFilterStyles.mobileDropdownArrow}
                          >
                            {mobileFilterOpen === "state" ? "▲" : "▼"}
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={[
                            deliveryFilterStyles.mobileDropdownButton,
                            mobileFilterOpen === "status" &&
                              deliveryFilterStyles.mobileDropdownButtonActive,
                            { marginLeft: 16 },
                          ]}
                          onPress={() =>
                            setMobileFilterOpen(
                              mobileFilterOpen === "status" ? null : "status",
                            )
                          }
                        >
                          <Text
                            style={deliveryFilterStyles.mobileDropdownLabel}
                          >
                            Order Status:{" "}
                          </Text>
                          <Text
                            style={deliveryFilterStyles.mobileDropdownValue}
                          >
                            {selectedStatuses.length === 0
                              ? "All"
                              : selectedStatuses.length === 1
                                ? renameLabel(
                                    (
                                      dataToBeConverted as Record<
                                        string,
                                        string
                                      >
                                    )[selectedStatuses[0]] ||
                                      selectedStatuses[0],
                                  )
                                : `${selectedStatuses.length} ${t("selected")}`}
                          </Text>
                          <Text
                            style={deliveryFilterStyles.mobileDropdownArrow}
                          >
                            {mobileFilterOpen === "status" ? "▲" : "▼"}
                          </Text>
                        </TouchableOpacity>
                      </ScrollView>

                      {mobileFilterOpen === "date" && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={[
                            deliveryFilterStyles.mobileChipRow,
                            { marginTop: 2 },
                          ]}
                        >
                          {dateFilters
                            .filter((c) => c !== "Date Range")
                            .map((category: string, index: number) => {
                              const isActive =
                                category === "All"
                                  ? selectedDates.length === 0
                                  : selectedDates.includes(category);
                              return (
                                <TouchableOpacity
                                  key={`date-${index}`}
                                  style={[
                                    deliveryFilterStyles.filterChip,
                                    isActive &&
                                      deliveryFilterStyles.filterChipActive,
                                  ]}
                                  onPress={() => {
                                    if (category === "Date Range") {
                                      setDateRangePickerOpen(true);
                                      return;
                                    }
                                    if (category === "All") {
                                      setSelectedDates([]);
                                      _setDateFilter("");
                                    } else {
                                      const newDates = selectedDates.includes(
                                        category,
                                      )
                                        ? []
                                        : [category];
                                      setSelectedDates(newDates);
                                      _setDateFilter(
                                        newDates.length === 0
                                          ? ""
                                          : newDates[0],
                                      );
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? deliveryFilterStyles.filterChipTextActive
                                        : deliveryFilterStyles.filterChipText
                                    }
                                  >
                                    {category === "Date Range" &&
                                    selectedDates.includes("Date Range")
                                      ? getDateRangeLabel()
                                      : category}
                                  </Text>
                                </TouchableOpacity>
                              );
                            })}
                        </ScrollView>
                      )}

                      {mobileFilterOpen === "state" && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={[
                            deliveryFilterStyles.mobileChipRow,
                            { marginTop: 2 },
                          ]}
                        >
                          {stateFilters.map(
                            (category: string, index: number) => {
                              const isActive =
                                category === "all"
                                  ? selectedStates.length === 0
                                  : selectedStates.includes(category);
                              return (
                                <TouchableOpacity
                                  key={`state-${index}`}
                                  style={[
                                    deliveryFilterStyles.filterChip,
                                    isActive &&
                                      deliveryFilterStyles.filterChipActive,
                                  ]}
                                  onPress={() => {
                                    if (category === "all") {
                                      setSelectedStates([]);
                                      _setStateFilter("all");
                                    } else {
                                      const newStates = selectedStates.includes(
                                        category,
                                      )
                                        ? selectedStates.filter(
                                            (s) => s !== category,
                                          )
                                        : [...selectedStates, category];
                                      setSelectedStates(newStates);
                                      _setStateFilter(
                                        newStates.length === 0
                                          ? "all"
                                          : newStates.join(","),
                                      );
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? deliveryFilterStyles.filterChipTextActive
                                        : deliveryFilterStyles.filterChipText
                                    }
                                  >
                                    {renameLabel(category)}
                                  </Text>
                                </TouchableOpacity>
                              );
                            },
                          )}
                        </ScrollView>
                      )}

                      {mobileFilterOpen === "status" && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={[
                            deliveryFilterStyles.mobileChipRow,
                            { marginTop: 2 },
                          ]}
                        >
                          {["All", ...availableStatuses].map(
                            (status, index) => {
                              const isActive =
                                status === "All"
                                  ? selectedStatuses.length === 0
                                  : selectedStatuses.includes(status);
                              return (
                                <TouchableOpacity
                                  key={`status-${index}`}
                                  style={[
                                    deliveryFilterStyles.filterChip,
                                    isActive &&
                                      deliveryFilterStyles.filterChipActive,
                                  ]}
                                  onPress={() => {
                                    if (status === "All") {
                                      setSelectedStatuses([]);
                                    } else {
                                      const newStatuses =
                                        selectedStatuses.includes(status)
                                          ? selectedStatuses.filter(
                                              (s) => s !== status,
                                            )
                                          : [...selectedStatuses, status];
                                      setSelectedStatuses(newStatuses);
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? deliveryFilterStyles.filterChipTextActive
                                        : deliveryFilterStyles.filterChipText
                                    }
                                  >
                                    {renameLabel(
                                      (
                                        dataToBeConverted as Record<
                                          string,
                                          string
                                        >
                                      )[status] || status,
                                    )}
                                  </Text>
                                </TouchableOpacity>
                              );
                            },
                          )}
                        </ScrollView>
                      )}
                    </View>
                  </>
                ) : (
                  <>
                    <View style={deliveryFilterStyles.quickFilterBar}>
                      <View style={{ flex: 1 }}>
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={
                            deliveryFilterStyles.quickFilterChipsContainer
                          }
                        >
                          <Text style={deliveryFilterStyles.quickFilterLabel}>
                            {t("quickFilter")}
                          </Text>

                          <TouchableOpacity
                            style={[
                              deliveryFilterStyles.mobileDropdownButton,
                              mobileFilterOpen === "date" &&
                                deliveryFilterStyles.mobileDropdownButtonActive,
                            ]}
                            onPress={() =>
                              setMobileFilterOpen(
                                mobileFilterOpen === "date" ? null : "date",
                              )
                            }
                          >
                            <Text
                              style={deliveryFilterStyles.mobileDropdownLabel}
                            >
                              {t("date")}:{" "}
                            </Text>
                            <Text
                              style={deliveryFilterStyles.mobileDropdownValue}
                            >
                              {selectedDates.length === 0
                                ? "All"
                                : selectedDates.length === 1
                                  ? selectedDates[0] === "Date Range"
                                    ? getDateRangeLabel()
                                    : selectedDates[0]
                                  : `${selectedDates.length} ${t("selected")}`}
                            </Text>
                            <Text
                              style={deliveryFilterStyles.mobileDropdownArrow}
                            >
                              {mobileFilterOpen === "date" ? "▲" : "▼"}
                            </Text>
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={[
                              deliveryFilterStyles.mobileDropdownButton,
                              mobileFilterOpen === "state" &&
                                deliveryFilterStyles.mobileDropdownButtonActive,
                              { marginLeft: 8 },
                            ]}
                            onPress={() =>
                              setMobileFilterOpen(
                                mobileFilterOpen === "state" ? null : "state",
                              )
                            }
                          >
                            <Text
                              style={deliveryFilterStyles.mobileDropdownLabel}
                            >
                              {t("state")}:{" "}
                            </Text>
                            <Text
                              style={deliveryFilterStyles.mobileDropdownValue}
                            >
                              {selectedStates.length === 0
                                ? "All"
                                : selectedStates.length === 1
                                  ? selectedStates[0]
                                  : `${selectedStates.length} ${t("selected")}`}
                            </Text>
                            <Text
                              style={deliveryFilterStyles.mobileDropdownArrow}
                            >
                              {mobileFilterOpen === "state" ? "▲" : "▼"}
                            </Text>
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={[
                              deliveryFilterStyles.mobileDropdownButton,
                              mobileFilterOpen === "status" &&
                                deliveryFilterStyles.mobileDropdownButtonActive,
                              { marginLeft: 8 },
                            ]}
                            onPress={() =>
                              setMobileFilterOpen(
                                mobileFilterOpen === "status" ? null : "status",
                              )
                            }
                          >
                            <Text
                              style={deliveryFilterStyles.mobileDropdownLabel}
                            >
                              Order Status:{" "}
                            </Text>
                            <Text
                              style={deliveryFilterStyles.mobileDropdownValue}
                            >
                              {selectedStatuses.length === 0
                                ? "All"
                                : selectedStatuses.length === 1
                                  ? renameLabel(
                                      (
                                        dataToBeConverted as Record<
                                          string,
                                          string
                                        >
                                      )[selectedStatuses[0]] ||
                                        selectedStatuses[0],
                                    )
                                  : `${selectedStatuses.length} ${t("selected")}`}
                            </Text>
                            <Text
                              style={deliveryFilterStyles.mobileDropdownArrow}
                            >
                              {mobileFilterOpen === "status" ? "▲" : "▼"}
                            </Text>
                          </TouchableOpacity>
                        </ScrollView>
                      </View>
                      <View
                        style={deliveryFilterStyles.quickFilterSearchSection}
                      >
                        <LabelBannerWithSearchBar
                          titleName={`${t("totalDelivery")}: ${deliveryPageLevelList.length}`}
                          handleSearch={onHandleSearch}
                          setRefresh={setRefresh}
                          isResetFields={isRefresh}
                          extraControls={
                            !(isSmallDevice || isMobileDevice) ? (
                              <RNView>
                                <TouchableOpacity
                                  ref={settingsBtnRef}
                                  style={{
                                    width:
                                      isSmallDevice || isMobileDevice ? 34 : 40,
                                    height:
                                      isSmallDevice || isMobileDevice ? 34 : 40,
                                    borderRadius:
                                      isSmallDevice || isMobileDevice ? 8 : 10,
                                    backgroundColor: columnSettingsOpen
                                      ? "#E0E7FF"
                                      : "#F3F4F6",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderWidth: 1,
                                    borderColor: columnSettingsOpen
                                      ? "#818CF8"
                                      : "#E2E8F0",
                                  }}
                                  onPress={() => {
                                    if (settingsBtnRef.current) {
                                      settingsBtnRef.current.measureInWindow(
                                        (
                                          x: number,
                                          y: number,
                                          width: number,
                                          height: number,
                                        ) => {
                                          setSettingsBtnPos({
                                            x,
                                            y,
                                            width,
                                            height,
                                          });
                                          setColumnSettingsOpen(
                                            !columnSettingsOpen,
                                          );
                                        },
                                      );
                                    } else {
                                      setColumnSettingsOpen(
                                        !columnSettingsOpen,
                                      );
                                    }
                                  }}
                                >
                                  <FeatherIcon
                                    name="settings"
                                    size={
                                      isSmallDevice || isMobileDevice ? 14 : 15
                                    }
                                    color={
                                      columnSettingsOpen ? "#56B7FD" : "#6B7280"
                                    }
                                  />
                                </TouchableOpacity>
                                <Modal
                                  visible={columnSettingsOpen}
                                  transparent={true}
                                  animationType="fade"
                                  onRequestClose={() =>
                                    setColumnSettingsOpen(false)
                                  }
                                >
                                  <Pressable
                                    style={{
                                      flex: 1,
                                      backgroundColor: "rgba(0,0,0,0.15)",
                                      ...(isSmallDevice || isMobileDevice
                                        ? {
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: 20,
                                          }
                                        : {}),
                                    }}
                                    onPress={() => setColumnSettingsOpen(false)}
                                  >
                                    <Pressable
                                      style={{
                                        ...(isSmallDevice || isMobileDevice
                                          ? { width: "100%", maxWidth: 320 }
                                          : {
                                              position: "absolute",
                                              top:
                                                settingsBtnPos.y +
                                                settingsBtnPos.height +
                                                6,
                                              left: settingsBtnPos.x,
                                              minWidth: 220,
                                            }),
                                        backgroundColor: "#fff",
                                        borderRadius: 12,
                                        borderWidth: 1,
                                        borderColor: "#E2E8F0",
                                        paddingVertical: 10,
                                        shadowColor: "#000",
                                        shadowOffset: { width: 0, height: 8 },
                                        shadowOpacity: 0.15,
                                        shadowRadius: 20,
                                        elevation: 10,
                                      }}
                                      onPress={(e) => e.stopPropagation()}
                                    >
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          fontWeight: "700",
                                          color: "#6B7280",
                                          paddingHorizontal: 16,
                                          paddingBottom: 8,
                                          textTransform: "uppercase",
                                          letterSpacing: 0.5,
                                        }}
                                      >
                                        {t("showHideColumns")}
                                      </Text>
                                      <View
                                        style={{
                                          height: 1,
                                          backgroundColor: "#F1F5F9",
                                          marginBottom: 4,
                                        }}
                                      />
                                      {/* Select All */}
                                      <TouchableOpacity
                                        style={{
                                          flexDirection: "row",
                                          alignItems: "center",
                                          paddingVertical: 8,
                                          paddingHorizontal: 16,
                                        }}
                                        onPress={() => {
                                          const allKeys = Object.keys(
                                            getAllHeaders(),
                                          ).filter((k) => k !== "");
                                          if (hiddenColumns.length === 0) {
                                            // Hide all
                                            const updated = [...allKeys];
                                            setHiddenColumns(updated);
                                            AsyncStorage.setItem(
                                              "delivery_hidden_columns",
                                              JSON.stringify(updated),
                                            );
                                          } else {
                                            // Show all
                                            setHiddenColumns([]);
                                            AsyncStorage.setItem(
                                              "delivery_hidden_columns",
                                              JSON.stringify([]),
                                            );
                                          }
                                        }}
                                      >
                                        <View
                                          style={{
                                            width: 20,
                                            height: 20,
                                            borderRadius: 4,
                                            borderWidth: 1.5,
                                            borderColor:
                                              hiddenColumns.length === 0
                                                ? "#56B7FD"
                                                : "#D1D5DB",
                                            backgroundColor:
                                              hiddenColumns.length === 0
                                                ? "#56B7FD"
                                                : "#fff",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginRight: 10,
                                          }}
                                        >
                                          {hiddenColumns.length === 0 && (
                                            <FeatherIcon
                                              name="check"
                                              size={13}
                                              color="#fff"
                                            />
                                          )}
                                        </View>
                                        <Text
                                          style={{
                                            fontSize: 14,
                                            color: "#111827",
                                            fontWeight: "700",
                                          }}
                                        >
                                          {t("selectAll")}
                                        </Text>
                                      </TouchableOpacity>
                                      <View
                                        style={{
                                          height: 1,
                                          backgroundColor: "#F1F5F9",
                                          marginBottom: 2,
                                        }}
                                      />
                                      <ScrollView
                                        style={{ maxHeight: 300 }}
                                        showsVerticalScrollIndicator={true}
                                      >
                                        {getOrderedKeys(getAllHeaders()).map(
                                          (key) => {
                                            if (key === "") return null;
                                            const value = getAllHeaders()[key];
                                            if (!value) return null;
                                            const isVisible =
                                              !hiddenColumns.includes(key);
                                            const isDragging =
                                              dragActiveKey === key;
                                            const isDragOver =
                                              dragOverKey === key;
                                            return (
                                              <RNView
                                                key={key}
                                                {...({
                                                  dataSet: { columnkey: key },
                                                } as any)}
                                                style={{
                                                  flexDirection: "row",
                                                  alignItems: "center",
                                                  paddingVertical: 8,
                                                  paddingHorizontal: 16,
                                                  opacity: isDragging
                                                    ? 0.35
                                                    : 1,
                                                  backgroundColor: isDragOver
                                                    ? "#EFF6FF"
                                                    : "transparent",
                                                  borderTopWidth: isDragOver
                                                    ? 2
                                                    : 0,
                                                  borderTopColor: "#56B7FD",
                                                }}
                                              >
                                                <Pressable
                                                  onPressIn={() =>
                                                    startColumnDrag(key)
                                                  }
                                                  style={
                                                    {
                                                      padding: 4,
                                                      marginRight: 6,
                                                      cursor: "grab",
                                                    } as any
                                                  }
                                                >
                                                  <FeatherIcon
                                                    name="menu"
                                                    size={14}
                                                    color="#9CA3AF"
                                                  />
                                                </Pressable>
                                                <TouchableOpacity
                                                  style={{
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    flex: 1,
                                                  }}
                                                  onPress={() =>
                                                    toggleColumn(key)
                                                  }
                                                >
                                                  <RNView
                                                    style={{
                                                      width: 20,
                                                      height: 20,
                                                      borderRadius: 4,
                                                      borderWidth: 1.5,
                                                      borderColor: isVisible
                                                        ? "#56B7FD"
                                                        : "#D1D5DB",
                                                      backgroundColor: isVisible
                                                        ? "#56B7FD"
                                                        : "#fff",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      marginRight: 10,
                                                    }}
                                                  >
                                                    {isVisible && (
                                                      <FeatherIcon
                                                        name="check"
                                                        size={13}
                                                        color="#fff"
                                                      />
                                                    )}
                                                  </RNView>
                                                  <Text
                                                    style={{
                                                      fontSize: 14,
                                                      color: isVisible
                                                        ? "#111827"
                                                        : "#9CA3AF",
                                                      fontWeight: isVisible
                                                        ? "600"
                                                        : "400",
                                                    }}
                                                  >
                                                    {t((value as any).name)}
                                                  </Text>
                                                </TouchableOpacity>
                                              </RNView>
                                            );
                                          },
                                        )}
                                      </ScrollView>
                                      {columnOrder.length > 0 && (
                                        <>
                                          <RNView
                                            style={{
                                              height: 1,
                                              backgroundColor: "#F1F5F9",
                                              marginTop: 4,
                                            }}
                                          />
                                          <TouchableOpacity
                                            style={{
                                              flexDirection: "row",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              paddingVertical: 10,
                                              paddingHorizontal: 16,
                                            }}
                                            onPress={resetColumnOrder}
                                          >
                                            <FeatherIcon
                                              name="rotate-ccw"
                                              size={13}
                                              color="#6B7280"
                                            />
                                            <Text
                                              style={{
                                                fontSize: 13,
                                                color: "#6B7280",
                                                fontWeight: "600",
                                                marginLeft: 6,
                                              }}
                                            >
                                              {t("resetOrder")}
                                            </Text>
                                          </TouchableOpacity>
                                        </>
                                      )}
                                    </Pressable>
                                  </Pressable>
                                </Modal>
                              </RNView>
                            ) : undefined
                          }
                        />
                      </View>
                    </View>
                    <View style={{ paddingHorizontal: 10, paddingVertical: 0 }}>
                      {mobileFilterOpen === "date" && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={
                            deliveryFilterStyles.mobileChipRow
                          }
                        >
                          {dateFilters.map(
                            (category: string, index: number) => {
                              const isActive =
                                category === "All"
                                  ? selectedDates.length === 0
                                  : selectedDates.includes(category);
                              return (
                                <TouchableOpacity
                                  key={`date-${index}`}
                                  style={[
                                    deliveryFilterStyles.filterChip,
                                    isActive &&
                                      deliveryFilterStyles.filterChipActive,
                                  ]}
                                  onPress={() => {
                                    if (category === "Date Range") {
                                      setDateRangePickerOpen(true);
                                      return;
                                    }
                                    if (category === "All") {
                                      setSelectedDates([]);
                                      _setDateFilter("");
                                    } else {
                                      const newDates = selectedDates.includes(
                                        category,
                                      )
                                        ? []
                                        : [category];
                                      setSelectedDates(newDates);
                                      _setDateFilter(
                                        newDates.length === 0
                                          ? ""
                                          : newDates[0],
                                      );
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? deliveryFilterStyles.filterChipTextActive
                                        : deliveryFilterStyles.filterChipText
                                    }
                                  >
                                    {category === "Date Range" &&
                                    selectedDates.includes("Date Range")
                                      ? getDateRangeLabel()
                                      : category}
                                  </Text>
                                </TouchableOpacity>
                              );
                            },
                          )}
                        </ScrollView>
                      )}

                      {mobileFilterOpen === "state" && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={
                            deliveryFilterStyles.mobileChipRow
                          }
                        >
                          {stateFilters.map(
                            (category: string, index: number) => {
                              const isActive =
                                category === "all"
                                  ? selectedStates.length === 0
                                  : selectedStates.includes(category);
                              return (
                                <TouchableOpacity
                                  key={`state-${index}`}
                                  style={[
                                    deliveryFilterStyles.filterChip,
                                    isActive &&
                                      deliveryFilterStyles.filterChipActive,
                                  ]}
                                  onPress={() => {
                                    if (category === "all") {
                                      setSelectedStates([]);
                                      _setStateFilter("all");
                                    } else {
                                      const newStates = selectedStates.includes(
                                        category,
                                      )
                                        ? selectedStates.filter(
                                            (s) => s !== category,
                                          )
                                        : [...selectedStates, category];
                                      setSelectedStates(newStates);
                                      _setStateFilter(
                                        newStates.length === 0
                                          ? "all"
                                          : newStates.join(","),
                                      );
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? deliveryFilterStyles.filterChipTextActive
                                        : deliveryFilterStyles.filterChipText
                                    }
                                  >
                                    {renameLabel(category)}
                                  </Text>
                                </TouchableOpacity>
                              );
                            },
                          )}
                        </ScrollView>
                      )}

                      {mobileFilterOpen === "status" && (
                        <ScrollView
                          horizontal
                          showsHorizontalScrollIndicator={false}
                          contentContainerStyle={{
                            paddingTop: 8,
                            paddingBottom: 4,
                          }}
                        >
                          {["All", ...availableStatuses].map(
                            (status, index) => {
                              const isActive =
                                status === "All"
                                  ? selectedStatuses.length === 0
                                  : selectedStatuses.includes(status);
                              return (
                                <TouchableOpacity
                                  key={`status-${index}`}
                                  style={[
                                    deliveryFilterStyles.filterChip,
                                    isActive &&
                                      deliveryFilterStyles.filterChipActive,
                                  ]}
                                  onPress={() => {
                                    if (status === "All") {
                                      setSelectedStatuses([]);
                                    } else {
                                      const newStatuses =
                                        selectedStatuses.includes(status)
                                          ? selectedStatuses.filter(
                                              (s) => s !== status,
                                            )
                                          : [...selectedStatuses, status];
                                      setSelectedStatuses(newStatuses);
                                    }
                                  }}
                                >
                                  <Text
                                    style={
                                      isActive
                                        ? deliveryFilterStyles.filterChipTextActive
                                        : deliveryFilterStyles.filterChipText
                                    }
                                  >
                                    {renameLabel(
                                      (
                                        dataToBeConverted as Record<
                                          string,
                                          string
                                        >
                                      )[status] || status,
                                    )}
                                  </Text>
                                </TouchableOpacity>
                              );
                            },
                          )}
                        </ScrollView>
                      )}
                    </View>
                  </>
                )}
                <DataTableWithPagination
                  selectable={true}
                  headers={tableHeaders}
                  rows={replaceDataValues(
                    deliveryPageLevelList,
                    dataToBeConverted,
                  )}
                  itemsPerPage={20}
                  isDataLoading={isSearched}
                  useModal={true}
                  nestedHeader={nestedTableHeaders}
                  isRowsExpandable={true}
                  setModalVisible={setDeliveryAttachmentModalVisible}
                  handleRowClick={onHandleRowClick}
                  setSelected={setSelectedDeliveryItem}
                  setSelectedDeliveryItem={setSelectedDeliveryItem}
                  isToExpandAllRows={_isDisplayViewOn}
                  rowKeyValue="DocNum"
                  nestedItemKeyValue="items"
                  isSubDetail={true}
                  isDetail={true}
                  isEdit={false}
                  isDelete={false}
                  columnsToNotHaveThousandSeparator={
                    columnsToNotHaveThousandsSeparator
                  }
                  isDeliveryAttachment={true}
                  showAttachmentIcon={false}
                  hideInfoIcon={false}
                  setDeliveryModalVisible={setDeliveryAttachmentModalVisible}
                  setDeliveryStatusModal={setDeliveryStatusModal}
                  handleSortColumn={onHandleSortColumn}
                  handleDeleteRow={function (id: string | number): void {
                    throw new Error("Function not implemented.");
                  }}
                  operationActions={navigateToReportDetails}
                  handleDownloadPdf={handleDownloadPdf}
                />
              </View>
            ) : (
              <View>
                <Spinner
                  size="small"
                  color="#74BBFF"
                  styles={{ flexDirection: "row", margin: "20%" }}
                />
              </View>
            )}
          </View>
        </View>
        <UploadAttachmentDeliveryModal
          deliveryAttachmentModalVisible={deliveryAttachmentModalVisible}
          setDeliveryAttachmentModalVisible={setDeliveryAttachmentModalVisible}
          selectedItem={selectedDeliveryItem}
        />

        <DownloadPdfDeliveryModal
          downloadPdfModalVisible={downloadPdfModalVisible}
          setDownloadPdfModalVisible={setDownloadPdfModalVisible}
          selectedItem={selectedDeliveryItem}
        />

        <DeliveryStatusConfirmModal
          modalVisible={deliveryStatusModal}
          setModalVisible={setDeliveryStatusModal}
          selectedItem={selectedDeliveryItem}
        />

        {/* @ts-ignore: DatePickerModal typing conflict */}
        <PaperProvider
          theme={{
            ...DefaultTheme,
            colors: {
              ...DefaultTheme.colors,
              primary: "#3B82F6",
              primaryContainer: "#DBEAFE",
              onPrimaryContainer: "#1E40AF",
              secondaryContainer: "#BFDBFE",
              onSecondaryContainer: "#1E3A5F",
              onSurface: "#1E293B",
              onSurfaceVariant: "#475569",
            },
          }}
        >
          <DatePickerModal
            locale="en-AU"
            mode="range"
            visible={dateRangePickerOpen}
            onDismiss={() => setDateRangePickerOpen(false)}
            startDate={customDateRange.startDate}
            endDate={customDateRange.endDate}
            onConfirm={({ startDate, endDate }: any) => {
              setDateRangePickerOpen(false);
              if (startDate && endDate) {
                // Normalize times to midnight
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(0, 0, 0, 0);
                setCustomDateRange({ startDate, endDate });
                setSelectedDates(["Date Range"]);
                _setDateFilter("Date Range");
              }
            }}
          />
        </PaperProvider>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    flexGrow: 1,
  },
  containerContent: {
    flexDirection: "column",
    alignSelf: "flex-start",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  fab: {
    bottom: -10,
    position: "absolute",
    zIndex: 1,
  },
});

const deliveryFilterStyles = StyleSheet.create({
  quickFilterBar: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    paddingTop: 8,
    paddingBottom: 4,
    paddingHorizontal: 10,
  },
  quickFilterChipsContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingRight: 12,
  },
  quickFilterLabel: {
    fontWeight: "700",
    fontSize: 13,
    color: "#374151",
    marginRight: 10,
  },
  quickFilterSearchSection: {
    flexShrink: 0,
    minWidth: 350,
  },
  mobileDropdownButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 6,
    paddingHorizontal: 12,
    backgroundColor: "#F1F5F9",
    borderRadius: 999,
    borderWidth: 1,
    borderColor: "#E2E8F0",
    alignSelf: "flex-start",
  },
  mobileDropdownButtonActive: {
    borderColor: "#61B8FF",
    backgroundColor: "#EFF6FF",
  },
  mobileDropdownLabel: {
    fontSize: 12,
    fontWeight: "600",
    color: "#6B7280",
  },
  mobileDropdownValue: {
    fontSize: 12,
    fontWeight: "700",
    color: "#1E40AF",
  },
  mobileDropdownArrow: {
    fontSize: 8,
    color: "#6B7280",
    marginLeft: 4,
  },
  mobileChipRow: {
    flexDirection: "row",
    paddingVertical: 2,
    paddingHorizontal: 4,
  },
  filterChip: {
    paddingVertical: 6,
    paddingHorizontal: 14,
    backgroundColor: "#F1F5F9",
    borderRadius: 999,
    marginRight: 12,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: "#E2E8F0",
  },
  filterChipActive: {
    backgroundColor: "#61B8FF",
    borderColor: "#61B8FF",
  },
  filterChipText: {
    fontSize: 13,
    color: "#475569",
    fontWeight: "500" as const,
  },
  filterChipTextActive: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600" as const,
  },
});
